import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CustomerTicketSummary } from './models/customer-ticket-summary.model';

export interface GameTicketState extends EntityState<CustomerTicketSummary> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'gameTickets', idKey: 'GameNumber' })
export class GameTicketStore extends EntityStore<GameTicketState> {
  constructor() {
    super();
  }
}
